import React, { useContext } from "react";
import Can from "../can/Can";
import { AppContext } from "../../App";
import { logs } from "../../rbac-consts";
import LogsTabsContainer from "./admin/LogsTabsContainer";

const LogsWrapper = () => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={logs.ADMIN}
      yes={() => (
        <LogsTabsContainer />
      )}
    />
  );
};

export default LogsWrapper;